import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeleteAllScenarioGrants = () => {
  const { mutate: deleteScenarioGrants, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_GRANT],
    {
      mutationFn: ({ scenarioId, sarOnly }: { sarOnly?: boolean; scenarioId: string }) =>
        ApiService.delete(
          {
            endpoint: BackendRoute.SCENARIOS,
            routePath: [scenarioId, 'grants-for-scenario', 'remove-all'],
          },
          {
            queryParams: {
              sarOnly: sarOnly || undefined,
            },
          },
        ),
    },
  );
  return { deleteScenarioGrants, isPending };
};
